import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #FF372F;
  padding: 8px;
  font-size: 14px;
  background: #000000;
`;

const BoldSpan = styled.span`
  font-weight: bold;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      © 2025 WSP New Zealand - <BoldSpan>BETA VERSION</BoldSpan>
    </FooterContainer>
  );
};

export default Footer;
